import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './config/auth.guard';
import { AppLayoutComponent } from './layout/app.layout.component';
import { DefinicaoSenhaComponent } from './login/definicao-senha/definicao-senha.component';
import { LoginComponent } from './login/login.component';
import { ClienteformComponent } from './pages/administracao/clientes/clientes/clienteform/clienteform.component';
import { ClientesComponent } from './pages/administracao/clientes/clientes/clientes.component';
import { BasesComponent } from './pages/administracao/infra/bases/bases.component';
import { ServidoresComponent } from './pages/administracao/infra/servidores/servidores.component';
import { PerfilComponent } from './pages/administracao/perfil/perfil.component';
import { PerfilformComponent } from './pages/administracao/perfil/perfilform/perfilform.component';
import { FornecedoresComponent } from './pages/integracoes/dadosmestres/fornecedores/fornecedores.component';
import { GruposmateriaisComponent } from './pages/integracoes/dadosmestres/gruposmateriais/gruposmateriais.component';
import { MateriaisComponent } from './pages/integracoes/dadosmestres/materiais/materiais.component';
import { UnidadesmedidasComponent } from './pages/integracoes/dadosmestres/unidadesmedidas/unidadesmedidas.component';
import { MunicipiosComponent } from './pages/integracoes/dadosmestres/municipios/municipios.component';
import { DepositosComponent } from './pages/integracoes/dadosmestres/depositos/depositos.component';
import { EquipamentosComponent } from './pages/integracoes/dadosmestres/equipamentos/equipamentos.component';
// import { AdiantamentoComponent } from './pages/integracoes/movimentacao/adiantamento/adiantamento.component';
import { BaixaconsumiveisComponent } from './pages/integracoes/movimentacao/baixaconsumiveis/baixaconsumiveis.component';
import { DepreciacaoComponent } from './pages/integracoes/movimentacao/depreciacao/depreciacao.component';
import { NotaFiscalsComponent } from './pages/integracoes/movimentacao/notafiscals/notafiscals.component';
import { PesagemComponent } from './pages/integracoes/movimentacao/pesagem/pesagem.component';
import { CapturaPesoComponent } from './pages/integracoes/movimentacao/capturapeso/capturapeso.component';
import { ProducaosComponent } from './pages/integracoes/movimentacao/producaos/producaos.component';
// import { ProvisaoComponent } from './pages/integracoes/movimentacao/provisao/provisao.component';
import { UsuarioformComponent } from './pages/administracao/usuarios/usuarioform/usuarioform.component';
import { UsuariosComponent } from './pages/administracao/usuarios/usuarios.component';
import { PainelcontratoComponent } from './pages/integracoes/contratos/painelcontrato/painelcontrato.component';
import { CustoconsumoComponent } from './pages/integracoes/custos/custoconsumo/custoconsumo.component';
import { CustodepreciacaoComponent } from './pages/integracoes/custos/custodepreciacao/custodepreciacao.component';
import { CustodespesageralComponent } from './pages/integracoes/custos/custodespesageral/custodespesageral.component';
import { CustohoramanutencaoComponent } from './pages/integracoes/custos/custohoramanutencao/custohoramanutencao.component';
import { PainelcustosComponent } from './pages/integracoes/custos/painelcustos/painelcustos.component';
import { AdiantamentoComponent } from './pages/integracoes/movimentacao/adiantamento/adiantamento.component';
import { ClasseAvaliacaoComponent } from './pages/integracoes/movimentacao/classeavaliacao/classeavaliacao.component';
import { ClasseAvaliacaoFormComponent } from './pages/integracoes/movimentacao/classeavaliacao/classeavaliacaoform/classeavaliacaoform.component';
import { TmaComponent } from './pages/integracoes/movimentacao/contratos/tma/tma.component';
import { TmaformComponent } from './pages/integracoes/movimentacao/contratos/tma/tmaform/tmaform.component';
import { NotaComponent } from './pages/integracoes/movimentacao/nota/nota.component';
import { NotaformComponent } from './pages/integracoes/movimentacao/nota/notaform/notaform.component';
import { Pesagem91pComponent } from './pages/integracoes/movimentacao/pesagem91p/pesagem91p.component';
import { Pesagem91pFormComponent } from './pages/integracoes/movimentacao/pesagem91p/pesagem91pform/pesagem91pform.component';
import { ProducaoComponent } from './pages/integracoes/movimentacao/producao/producao.component';
import { ProducaoParamComponent } from './pages/integracoes/movimentacao/producaoparam/producaoparam.component';
import { ProducaoParamFormComponent } from './pages/integracoes/movimentacao/producaoparam/producaoparamform/producaoparamform.component';
import { ProvisaoComponent } from './pages/integracoes/movimentacao/provisao/provisao.component';
import { Provisao77pComponent } from './pages/integracoes/movimentacao/provisao77p/provisao77p.component';
import { Provisao77pFormComponent } from './pages/integracoes/movimentacao/provisao77p/provisao77pform/provisao77pform.component';
import { ServicosComponent } from './pages/integracoes/movimentacao/servicos/servicos.component';
import { ParametrizacaoComponent } from './pages/integracoes/parametrizacao/parametrizacao.component';
import { DeposiformComponent } from './pages/painelinsumos/deposito/deposiform/deposiform.component';
import { DepositoComponent } from './pages/painelinsumos/deposito/deposito.component';
import { DetalhesComponent } from './pages/painelinsumos/detalhes/detalhes.component';
import { InsumosExcecaoComponent } from './pages/painelinsumos/insumos-excecao/insumos-excecao.component';
import { InsumosexcecaoformComponent } from './pages/painelinsumos/insumos-excecao/insumosexcecaoform/insumosexcecaoform.component';
import { PainelComponent } from './pages/painelinsumos/painel/painel.component';
import { TransferenciaComponent } from './pages/painelinsumos/transferencia/transferencia.component';
import {FuncoesComponent} from "./pages/administracao/funcoes/funcoes.component";
import {FuncoesFormComponent} from "./pages/administracao/funcoes/funcoes-form/funcoes-form.component";
import {ContratosPagamentoComponent} from "./pages/integracoes/contratos/pagamento/pagamento-contrato.component";
import {ContratosComErrosComponent} from "./pages/integracoes/contratos/com-erros/com-erros.component";
import {
  ContratosPagamentosNaoIntegradosComponent
} from "./pages/integracoes/contratos/pagamentos-nao-integrados/pagamento-nao-integrados.component";
import {
  ContratosPendentesCancelamentoComponent
} from "./pages/integracoes/contratos/pendentes-cancelamento/contratos-pendentes-cancelamento.component";
import {ContratosCanceladosComponent} from "./pages/integracoes/contratos/cancelados/cancelados.component";
import {ContratosIntegradosComponent} from "./pages/integracoes/contratos/integrados/contratos-integrados.component";
import {ContratosModificadosComponent} from "./pages/integracoes/contratos/modificados/modificados.component";
import {ContratosNovosComponent} from "./pages/integracoes/contratos/novos/novos.component";
import {ContratosProcessosComponent} from "./pages/integracoes/contratos/processos/processos.component";
import {
  ContratosIntegracaoComponent
} from "./pages/integracoes/contratos/integracao/contratos-integracao.component";
import {BuscanotafiscalComponent} from "./pages/integracoes/movimentacao/buscanotafiscal/buscanotafiscal.component";
import { PainelfluxocaixaComponent } from './pages/integracoes/movimentacao/painelfluxocaixa/painelfluxocaixa.component';
import { FluxocaixadespesasComponent } from './pages/integracoes/movimentacao/fluxocaixadespesas/fluxocaixadespesas.component';
import { FluxocaixareceitasComponent } from './pages/integracoes/movimentacao/fluxocaixareceitas/fluxocaixareceitas.component';
import { FluxocaixacustoscalculadosComponent } from './pages/integracoes/movimentacao/fluxocaixacustoscalculados/fluxocaixacustoscalculados.component';
import { ContascontabeisComponent } from './pages/integracoes/dadosmestres/contascontabeis/contascontabeis.component';
import { CentrodecustosComponent } from './pages/integracoes/dadosmestres/centrodecustos/centrodecustos.component';
import { PainelproducaoretornoComponent } from './pages/integracoes/movimentacao/painelproducaoretorno/painelproducaoretorno.component';
import { ProCampoComponent} from "./pages/producao/analise/campo/procampo.component";
import {ProvariaveisComponent} from "./pages/producao/analise/variaveis/provariaveis.component";
import {ProanalisesComponent} from "./pages/producao/analise/analises/proanalises.component";
import { AbastecimentosLubrificantesComponent } from './pages/integracoes/movimentacao/abastecimentos-lubrificantes/abastecimentos-lubrificantes.component';
import { ContratosIntegracaoPadraoComponent } from "./pages/integracoes/contratos/integracao-padrao/contratos-integracao-padrao.component";
import { TransferenciaInsumosComponent } from './pages/integracoes/movimentacao/transferencia-insumos/transferencia-insumos.component';
import { DepositoResponsavelComponent } from './pages/integracoes/movimentacao/transferencia-insumos/deposito-responsavel/deposito-responsavel.component';
import { DepositoResponsavelFormComponent } from './pages/integracoes/movimentacao/transferencia-insumos/deposito-responsavel/deposito-responsavel-form/deposito-responsavel-form.component';
import { BalancaConfigComponent } from './pages/integracoes/parametrizacao/balanca/balanca.component';
import { AnalisePesagemConfigComponent } from './pages/integracoes/parametrizacao/analisepesagem/analisepesagem.component';
import { PainelAprovacaoHistoricoComponent } from './pages/workflow/painel-aprovacao-historico/painel-aprovacao-historico.component';
import { RequisicaoDetalhadaComponent } from './pages/workflow/requisicao-detalhada/requisicao-detalhada.component';
import { ConfiguracaoWorkflowComponent } from './pages/workflow/configuracao-workflow/configuracao-workflow.component';
import { WorkflowEditarComponent } from './pages/workflow/workflow-editar/workflow-editar.component';

// SmartInteg
import { ProvedorListComponent } from './pages/smartinteg/provedores/provedor-list/provedor-list.component';
import { ProvedorFormComponent } from './pages/smartinteg/provedores/provedor-form/provedor-form.component';
import { DashboardComponent } from './pages/smartinteg/dashboard/dashboard.component';
import { ProvedorConexoesComponent } from './pages/smartinteg/provedores/provedor-conexoes/provedor-conexoes.component';
import { ProcessoListComponent } from './pages/smartinteg/processos/processo-list/processo-list.component';
import { ProcessoFormComponent } from './pages/smartinteg/processos/processo-form/processo-form.component';
import { ProcessoWizardComponent } from './pages/smartinteg/processos/processo-wizard/processo-wizard.component';
import { ProcessoFluxoComponent } from './pages/smartinteg/processos/processo-fluxo/processo-fluxo.component';
import { ProcessoExecutorComponent } from './pages/smartinteg/processos/processo-executor/processo-executor.component';
import { RecursoListComponent } from './pages/smartinteg/recursos/recurso-list/recurso-list.component';
import { ComandoListComponent } from './pages/smartinteg/comandos/comando-list/comando-list.component';
import { MapeamentoListComponent } from './pages/smartinteg/mapeamentos/mapeamento-list/mapeamento-list.component';
import { PublicacaoListComponent } from './pages/smartinteg/publicacoes/publicacao-list/publicacao-list.component';

// SmartInteg - Monitoramento
import { DashboardMonitoramentoComponent } from './pages/smartinteg/monitor/dashboard-monitoramento/dashboard-monitoramento.component';
import { ProcessoMonitorComponent } from './pages/smartinteg/monitor/processo-monitor/processo-monitor.component';
import { RegistroRecebidoListComponent } from './pages/smartinteg/monitor/registro-recebido-list/registro-recebido-list.component';
import { RegistroVisualizacaoListComponent } from './pages/smartinteg/monitor/registro-visualizacao-list/registro-visualizacao-list.component';
import { ProcessoDetalheMonitorComponent } from './pages/smartinteg/monitor/processo-detalhe-monitor/processo-detalhe-monitor.component';
import { RegistroDetalheComponent } from './pages/smartinteg/monitor/registro-detalhe/registro-detalhe.component';



const routes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: 'home', component: AppLayoutComponent, canActivate: [authGuard] },
      {
            path: 'workflow',
            children: [
              {
                path: '',
                component: PainelAprovacaoHistoricoComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_ADMIN_CLIENTE_USUARIOS', 'ROLE_ADMIN_MASTER','ROLE_ADMIN_CLIENTE'] },
              },
              {
                path: 'requisicao/:id',
                component: RequisicaoDetalhadaComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_ADMIN_CLIENTE_USUARIOS', 'ROLE_ADMIN_MASTER','ROLE_ADMIN_CLIENTE'] },
              },
            ],
          },
      {
        path: 'administracao',
        data: { roles: ['ROLE_ADMIN_MASTER'] },
        children: [
          {
            path: 'infra',
            children: [
              {
                path: 'servidores',
                component: ServidoresComponent,
                canActivate: [authGuard],
                data: { roles: ['"ROLE_ADMIN_MASTER_INFRA"', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'bases',
                component: BasesComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_ADMIN_MASTER_INFRA', 'ROLE_ADMIN_MASTER'] },
              },
            ],
          },
          {
            path: 'clientes',
            children: [
              {
                path: '',
                component: ClientesComponent,
                canActivate: [authGuard],
                data: { roles: ['"ROLE_ADMIN_MASTER_CLIENTES"', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'novo',
                component: ClienteformComponent,
                canActivate: [authGuard],
                data: { roles: ['"ROLE_ADMIN_MASTER_CLIENTES"', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'editar/:id',
                component: ClienteformComponent,
                canActivate: [authGuard],
                data: { roles: ['"ROLE_ADMIN_MASTER_CLIENTES"', 'ROLE_ADMIN_MASTER'] },
              },
            ],
          },
          {
            path: 'perfil',
            children: [
              {
                path: '',
                component: PerfilComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_ADMIN_CLIENTE_PERFIS', 'ROLE_ADMIN_MASTER','ROLE_ADMIN_CLIENTE'] },
              },
              {
                path: 'novo',
                component: PerfilformComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_ADMIN_CLIENTE_PERFIS', 'ROLE_ADMIN_MASTER','ROLE_ADMIN_CLIENTE'] },
              },
              {
                path: 'editar/:id',
                component: PerfilformComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_ADMIN_CLIENTE_PERFIS', 'ROLE_ADMIN_MASTER','ROLE_ADMIN_CLIENTE'] },
              },
            ],
          },
          {
            path: 'usuarios',
            children: [
              {
                path: '',
                component: UsuariosComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_ADMIN_CLIENTE_USUARIOS', 'ROLE_ADMIN_MASTER','ROLE_ADMIN_CLIENTE'] },
              },
              {
                path: 'novo',
                component: UsuarioformComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_ADMIN_CLIENTE_USUARIOS', 'ROLE_ADMIN_MASTER','ROLE_ADMIN_CLIENTE'] },
              },
              {
                path: 'editar/:id',
                component: UsuarioformComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_ADMIN_CLIENTE_USUARIOS', 'ROLE_ADMIN_MASTER','ROLE_ADMIN_CLIENTE'] },
              },
            ],
          },
          {
            path: 'funcao',
            children: [
              {
                path: '',
                component: FuncoesComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_ADMIN_CLIENTE_PERFIS', 'ROLE_ADMIN_MASTER','ROLE_ADMIN_CLIENTE'] },
              },
              {
                path: 'novo',
                component: FuncoesFormComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_ADMIN_CLIENTE_PERFIS', 'ROLE_ADMIN_MASTER','ROLE_ADMIN_CLIENTE'] },
              },
              {
                path: 'editar/:id',
                component: FuncoesFormComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_ADMIN_CLIENTE_PERFIS', 'ROLE_ADMIN_MASTER','ROLE_ADMIN_CLIENTE'] },
              },
            ],
          },
          {
            path: 'workflows',
            children: [
              {
                path: '',
                component: ConfiguracaoWorkflowComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_ADMIN_CLIENTE_PERFIS', 'ROLE_ADMIN_MASTER','ROLE_ADMIN_CLIENTE'] },
              },
              {
                path: 'editar/:id',
                component: WorkflowEditarComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_ADMIN_CLIENTE_PERFIS', 'ROLE_ADMIN_MASTER','ROLE_ADMIN_CLIENTE'] },
              },
            ],
          }

        ],
      },
      {
        path: 'integracoes',
        data: { roles: ['ROLE_INTEG', 'ROLE_ADMIN_MASTER'] },
        children: [
          {
            path: 'parametrizacao',
            component: ParametrizacaoComponent,
            canActivate: [authGuard],
            data: { roles: ['ROLE_INTEG_PARAM', 'ROLE_ADMIN_MASTER'] },
          },
          {
            path: 'parametrizacao/balanca',
            component: BalancaConfigComponent,
            canActivate: [authGuard],
            data: { roles: ['ROLE_INTEG_PARAM_BALANCA', 'ROLE_ADMIN_MASTER'] },
          },
          {
            path: 'parametrizacao/analisepesagem',
            component: AnalisePesagemConfigComponent,
            canActivate: [authGuard],
            data: { roles: ['ROLE_INTEG_PARAM_ANALISE_PESAGEM', 'ROLE_ADMIN_MASTER'] },
          },
          {
            path: 'dadosmestres',
            children: [
              {
                path: 'materiais',
                component: MateriaisComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MESTRES_MAT', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'unidadesmedidas',
                component: UnidadesmedidasComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MESTRES_UM', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'municipios',
                component: MunicipiosComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MESTRES_MUN', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'depositos',
                component: DepositosComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MESTRES_DEPOSITO', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'equipamentos',
                component: EquipamentosComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MESTRES_EQUIPAMENTOS', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'fornecedores',
                component: FornecedoresComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MESTRES_FORNEC', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'gruposmateriais',
                component: GruposmateriaisComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MESTRES_GRPMAT', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'centrocustos',
                component: CentrodecustosComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MESTRES_CENTROCUSTOS', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'contascontabeis',
                component: ContascontabeisComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MESTRES_CONTASCONTAB', 'ROLE_ADMIN_MASTER'] },
              },
            ],
          },
          {
            path: 'movimentacoes',
            children: [
              {
                path: 'contratos',
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_CONTRATO', 'ROLE_ADMIN_MASTER', 'ROLE_INTEG_MOVIMEN_CONTRATO_PADRAO'] },
                children: [
                  {
                    path: 'integracao-padrao',
                    component: ContratosIntegracaoPadraoComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_CONTRATO_PADRAO', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'integracao',
                    component: ContratosIntegracaoComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_CONTRATO', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'novos',
                    component: ContratosNovosComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_CONTRATO', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'modificados',
                    component: ContratosModificadosComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_CONTRATO', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'integrados',
                    component: ContratosIntegradosComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_CONTRATO', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'cancelados',
                    component: ContratosCanceladosComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_CONTRATO', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'cancelados/pendentes',
                    component: ContratosPendentesCancelamentoComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_CONTRATO', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'nao-integrados',
                    component: ContratosPagamentosNaoIntegradosComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_CONTRATO', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'erros',
                    component: ContratosComErrosComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_CONTRATO', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'pagamento',
                    component: ContratosPagamentoComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_CONTRATO', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'processos',
                    component: ContratosProcessosComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_CONTRATO', 'ROLE_ADMIN_MASTER'] },
                  },
                ]
              },
              {
                path: 'custo',
                component: PainelcustosComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_CUSTO', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'custo/depreciacao',
                component: CustodepreciacaoComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_CUSTO', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'custo/despesageral',
                component: CustodespesageralComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_CUSTO', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'custo/consumo',
                component: CustoconsumoComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_CUSTO', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'custo/horamanutencao',
                component: CustohoramanutencaoComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_CUSTO', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'fluxocaixa',
                component: PainelfluxocaixaComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_FLUXOCAIXA', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'fluxocaixa/despesas',
                component: FluxocaixadespesasComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_FLUXOCAIXA', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'fluxocaixa/receitas',
                component: FluxocaixareceitasComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_FLUXOCAIXA', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'fluxocaixa/custoscalculados',
                component: FluxocaixacustoscalculadosComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_FLUXOCAIXA', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'consumiveis',
                component: BaixaconsumiveisComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_BAIXA', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'pesagens',
                component: PesagemComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_PESAGEM', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'capturapeso',
                component: CapturaPesoComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_BALANCA', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'depreciacoes',
                component: DepreciacaoComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_DEPREC', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'producaoretorno',
                component: PainelproducaoretornoComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_PRODUCAOIND', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'producao',
                component: ProducaoComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_PRODIND', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'nota',
                data: { roles: ['ROLE_INTEG_MOVIMEN_NOTAFIS', 'ROLE_ADMIN_MASTER'] },
                children: [
                  {
                    path: '',
                    component: NotaComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_NOTAFIS', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'novo',
                    component: NotaformComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_NOTAFIS', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'editar/:id',
                    component: NotaformComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_NOTAFIS', 'ROLE_ADMIN_MASTER'] },
                  },
                ],
              },
              {
                path: 'provisoes',
                component: ProvisaoComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_PROV', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'producaos',
                component: ProducaosComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_PRODIND', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'adiantamentos',
                component: AdiantamentoComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_ADIANT', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'servicos',
                component: ServicosComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_SERV', 'ROLE_ADMIN_MASTER'] },
              },

              {
                path: 'notafiscals',
                component: NotaFiscalsComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_NOTAFIS', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'buscanotafiscal',
                component: BuscanotafiscalComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_NOTAFIS', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'provisao77p',
                data: { roles: ['ROLE_INTEG_PARAM_PROV', 'ROLE_ADMIN_MASTER'] },
                children: [
                  {
                    path: '',
                    component: Provisao77pComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_PARAM_PROV', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'novo',
                    component: Provisao77pFormComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_PARAM_PROV', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'editar/:id',
                    component: Provisao77pFormComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_PARAM_PROV', 'ROLE_ADMIN_MASTER'] },
                  },
                ],
              },

              {
                path: 'notafiscals',
                component: NotaFiscalsComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_MOVIMEN_NOTAFIS', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'classeavaliacao',
                data: { roles: ['ROLE_INTEG_PARAM_CLASAVAL', 'ROLE_ADMIN_MASTER'] },
                children: [
                  {
                    path: '',
                    component: ClasseAvaliacaoComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_PARAM_CLASAVAL', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'novo',
                    component: ClasseAvaliacaoFormComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_PARAM_CLASAVAL', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'editar/:id',
                    component: ClasseAvaliacaoFormComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_PARAM_CLASAVAL', 'ROLE_ADMIN_MASTER'] },
                  },
                ],
              },
              {
                path: 'producaoparam',
                data: { roles: ['ROLE_INTEG_PARAM_PRODUCAO', 'ROLE_ADMIN_MASTER'] },
                children: [
                  {
                    path: '',
                    component: ProducaoParamComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_PARAM_PRODUCAO', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'novo',
                    component: ProducaoParamFormComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_PARAM_PRODUCAO', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'editar/:empCodemp/:varCodigo/:sufCodigo',
                    component: ProducaoParamFormComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_PARAM_PRODUCAO', 'ROLE_ADMIN_MASTER'] },
                  },
                ],
              },
              {
                path: 'pesagem91p',
                // data: { roles: ['RL_MV_PESAGEM', 'ROLE_ADMIN_MASTER'] },
                children: [
                  {
                    path: '',
                    component: Pesagem91pComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_PARAM_PESAGEM', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'novo',
                    component: Pesagem91pFormComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_PARAM_PESAGEM', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'editar/:id',
                    component: Pesagem91pFormComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_PARAM_PESAGEM', 'ROLE_ADMIN_MASTER'] },
                  },
                ],
              },
              {
                path: 'tma',
                data: { roles: ['ROLE_INTEG_MOVIMEN_CONTRATO', 'ROLE_ADMIN_MASTER'] },
                children: [
                  {
                    path: '',
                    component: TmaComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_CONTRATO', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'novo',
                    component: TmaformComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_CONTRATO', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'editar/:id',
                    component: TmaformComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_MOVIMEN_CONTRATO', 'ROLE_ADMIN_MASTER'] },
                  },
                ],
              },
              {
                path: 'abastecimentos-lubrificantes',
                component: AbastecimentosLubrificantesComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_ABAST_LUBS', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'transferencia-insumos',
                canActivate: [authGuard],
                data: { roles: ['ROLE_INTEG_TRANSF_INSUMOS', 'ROLE_ADMIN_MASTER'] },
                children: [
                  {
                    path: '',
                    component: TransferenciaInsumosComponent,
                    canActivate: [authGuard],
                    data: { roles: ['ROLE_INTEG_TRANSF_INSUMOS', 'ROLE_ADMIN_MASTER'] },
                  },
                  {
                    path: 'deposito-responsavel',
                    children: [
                      {
                        path: '',
                        component: DepositoResponsavelComponent,
                        canActivate: [authGuard],
                        data: { roles: ['ROLE_INTEG_PARAM_TRANSF_RESP_DEP', 'ROLE_ADMIN_MASTER'] },
                      },
                      {
                        path: 'novo',
                        component: DepositoResponsavelFormComponent,
                        canActivate: [authGuard],
                        data: { roles: ['ROLE_INTEG_PARAM_TRANSF_RESP_DEP', 'ROLE_ADMIN_MASTER'] },
                      },
                      {
                        path: 'editar/:id',
                        component: DepositoResponsavelFormComponent,
                        canActivate: [authGuard],
                        data: { roles: ['ROLE_INTEG_PARAM_TRANSF_RESP_DEP', 'ROLE_ADMIN_MASTER'] },
                      },
                    ],
                  },
                ],
              },
            ],
          },

        ],
      },

      // SmartInteg - Rotas
      {
        path: 'smartinteg',
        // canActivate: [authGuard],
        // data: { roles: ['ROLE_SMARTINTEG', 'ROLE_ADMIN_MASTER'] },
        children: [
          { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
          {
            path: 'dashboard',
            component: DashboardComponent,
          },
          {
            path: 'provedores',
            children: [
              {
                path: '',
                component: ProvedorListComponent,
              },
              {
                path: 'novo',
                component: ProvedorFormComponent,
              },
              {
                path: 'editar/:id',
                component: ProvedorFormComponent,
              },
              {
                path: ':provedorId/conexoes',
                component: ProvedorConexoesComponent,
              },
            ],
          },
          {
            path: 'processos',
            children: [
              {
                path: '',
                component: ProcessoListComponent,
              },
              {
                path: 'novo',
                component: ProcessoFormComponent,
              },
              {
                path: 'editar/:id',
                component: ProcessoFormComponent,
              },
              {
                path: ':processoId/wizard',
                component: ProcessoWizardComponent,
              },
              {
                path: ':processoId/fluxo',
                component: ProcessoFluxoComponent,
              },
              {
                path: ':processoId/executar',
                component: ProcessoExecutorComponent,
              },
            ],
          },
          {
            path: 'recursos',
            component: RecursoListComponent,
          },
          {
            path: 'comandos',
            component: ComandoListComponent,
          },
          {
            path: 'mapeamentos',
            component: MapeamentoListComponent,
          },
          {
            path: 'publicacoes',
            component: PublicacaoListComponent,
          },

          // SmartInteg - Monitoramento
          {
            path: 'monitor',
            children: [
              { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
              {
                path: 'dashboard',
                component: DashboardMonitoramentoComponent,
              },
              {
                path: 'processos',
                component: ProcessoMonitorComponent,
              },
              {
                path: 'processos/:id',
                component: ProcessoDetalheMonitorComponent,
              },
              {
                path: 'processos/:id/recebidos',
                component: RegistroRecebidoListComponent,
              },
              {
                path: 'processos/:id/visualizacao',
                component: RegistroVisualizacaoListComponent,
              },
              {
                path: 'registros/:id',
                component: RegistroDetalheComponent,
              },
            ]
          },
        ],
      },

      {
        path: 'painelinsumos',
        data: { roles: ['ROLE_MONITORINSUMO', 'ROLE_ADMIN_MASTER'] },
        children: [
          {
            path: '',
            component: PainelComponent,
            canActivate: [authGuard],
            data: { roles: ['ROLE_MONITORINSUMO_PAINEL', 'ROLE_ADMIN_MASTER'] },
          },
          {
            path: 'painel',
            component: PainelComponent,
            canActivate: [authGuard],
            data: { roles: ['ROLE_MONITORINSUMO_PAINEL', 'ROLE_ADMIN_MASTER'] },
          },
          {
            path: 'detalhes/:id',
            component: DetalhesComponent,
            data: { roles: ['ROLE_MONITORINSUMO_PAINEL', 'ROLE_ADMIN_MASTER'] },
          },
          {
            path: 'deposito',
            component: DepositoComponent,
            canActivate: [authGuard],
            data: { roles: ['ROLE_MONITORINSUMO_DEPOSITO', 'ROLE_ADMIN_MASTER'] },
          },
          {
            path: 'deposito/editar/:id',
            component: DeposiformComponent,
            canActivate: [authGuard],
            data: { roles: ['ROLE_MONITORINSUMO_DEPOSITO', 'ROLE_ADMIN_MASTER'] },
          },
          {
            path: 'transferencia/:id/:tipo',
            component: TransferenciaComponent,
            canActivate: [authGuard],
            data: { roles: ['ROLE_MONITORINSUMO_PAINEL', 'ROLE_ADMIN_MASTER'] },
          },
          {
            path: 'insumoExcecao',
            canActivate: [authGuard],
            data: { roles: ['ROLE_MONITORINSUMO_MATEXC', 'ROLE_ADMIN_MASTER'] },
            children: [
              {
                path: '',
                component: InsumosExcecaoComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_MONITORINSUMO_MATEXC', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'novo',
                component: InsumosexcecaoformComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_MONITORINSUMO_MATEXC', 'ROLE_ADMIN_MASTER'] },
              },
              {
                path: 'editar/:id',
                component: InsumosexcecaoformComponent,
                canActivate: [authGuard],
                data: { roles: ['ROLE_MONITORINSUMO_MATEXC', 'ROLE_ADMIN_MASTER'] },
              },
            ]
          },          
        ],
      },
      {
        path: 'producao-analise',
        data: { roles: ['ROLE_PRODUCAO_ANALISE', 'ROLE_ADMIN_MASTER'] },
        children: [
          {
            path: 'campos',
            component: ProCampoComponent,
            canActivate: [authGuard],
            data: { roles: ['ROLE_PRODUCAO_ANALISE_CAMPOS', 'ROLE_ADMIN_MASTER'] }
          },
          {
            path: 'variaveis',
            component: ProvariaveisComponent,
            canActivate: [authGuard],
            data: { roles: ['ROLE_PRODUCAO_ANALISE_VARIAVEIS', 'ROLE_ADMIN_MASTER'] }
          },
          {
            path: 'analises',
            component: ProanalisesComponent,
            canActivate: [authGuard],
            data: { roles: ['ROLE_PRODUCAO_ANALISE_ANALISES', 'ROLE_ADMIN_MASTER'] }
          }
        ]
      }

    ],
  },
  { path: 'login', component: LoginComponent },
  { path: 'redefinicaosenha', component: DefinicaoSenhaComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
